module.exports = __webpack_public_path__ + "img/0-112.1580940e.jpg";